<script>
import { mapGetters, mapActions } from "vuex";
import { required, minLength, maxLength } from "vuelidate/lib/validators"; // for validators
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Layout from "../../layouts/main";
import {swal} from '../../../helpers/handle_error.js';
import AlertError from '@/components/alert_error'
import Admin from '../../../model/admin.js';
import { VueContentLoading } from 'vue-content-loading';

export default {
  page: {
    title: "تعديل بيانات المدير",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, AlertError, VueContentLoading},
  data() {
    return {
      // title
      title: "تعديل بيانات المدير",
      items: [
        {
          text: "ادارة المدراء",
          href: "/admins",
        },
        {
          text: "تعديل بيانات المدير",
          active: true,
        },
      ],

      //Page errors.
      errors: [],

      // vuelidate
      id: this.$route.params.id,
      admin: new Admin,
      submitadd: false,
      loadingButton: false,
      loadingContent: false,
    };
  },
  // vuelidate
  validations: {
    admin: {
      name: {required, minLength: minLength(2), maxLength: maxLength(150)},
      username: {required, minLength: minLength(3), maxLength: maxLength(30)},
      description: {maxLength: maxLength(255)},
      active: {required},
    }  
  },
  computed: {
    ...mapGetters('admin', {getAdmin: 'getAdmin', roles: 'getRoles'})
  },
 methods: {
  ...mapActions('admin', ['getRoles', 'get', 'edit']),
    handleError(error){
      if(error.response.status == 422) this.errors = Object.values(error.response.data.errors)
      else this.errors = [`Error Code : ${error.response.status}  Message : ${error.response.data.message}`]
    },
    resetForm(){
      this.submitadd = false
      this.loadingButton = false
      this.errors = []
      this.admin.reset()
    },
    formEditAdmin() { 
      this.submitadd = true
      this.$v.$touch();
      if(this.$v.$error) return

      // to form submit after this
      this.loadingButton = true
      this.errors = [];

      this.edit({id: this.id, admin: this.admin})
      .then((response)=>{
        swal.success(response.data.message)
        this.loadingButton = false
      })
      .catch((error)=>{
        this.handleError(error)
        this.loadingButton = false
      })
    }
  },
  created(){
    Promise.all([
      this.getRoles(),
      this.get(this.id).then(()=>this.admin = this.getAdmin)
    ])
    .then(()=>this.loadingContent = true)
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">

            <AlertError :errors="errors"/>

            <b-form v-if="this.loadingContent" @submit.prevent="formEditAdmin">

              <div class="row mt-3">
                <b-form-group class="col-md-6 mb-3" label="الاسم :" label-for="name">
                    <b-form-input id="name" type="text" v-model="admin.name" :class="{ 'is-invalid': submitadd && $v.admin.name.$error }" placeholder="ادخل الاسم"></b-form-input>
                    <div v-if="submitadd && $v.admin.name.$error" class="invalid-feedback">
                      <span v-if="!$v.admin.name.required"> هذا الحقل الزامي </span>
                      <span v-if="!$v.admin.name.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 4 احرف على الاقل . </span>
                      <span v-if="!$v.admin.name.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 150 حرف على الاكثر . </span>
                    </div>
                </b-form-group>
                <b-form-group class="col-md-6 mb-3" label="الوصف  :" label-for="description">
                    <b-form-input id="description" type="text" v-model="admin.description" :class="{ 'is-invalid': submitadd && $v.admin.description.$error }" placeholder="ادخل الوصف"></b-form-input>
                    <div v-if="submitadd && $v.admin.description.$error" class="invalid-feedback">
                      <span v-if="!$v.admin.description.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 255 حرف على الاكثر . </span>
                    </div>
                </b-form-group>
                <b-form-group class="col-md-6 mb-3" label="تفعيل الحساب :" label-for="active">
                    <select class="form-control select-p" v-model="admin.active" :class="{ 'is-invalid': submitadd && $v.admin.active.$error }" id="active">
                      <option value="">حدد تفعيل الحساب</option>
                      <option value="1">مفعل</option>
                      <option value="0">غير مفعل</option>
                    </select>
                    <div v-if="submitadd && $v.admin.active.$error" class="invalid-feedback">
                      <span v-if="!$v.admin.active.required"> هذا الحقل الزامي </span>
                    </div>
                </b-form-group>
                <b-form-group class="col-md-6 mb-3" label="اسم المستخدم :" label-for="username">
                    <b-form-input id="username" type="text" v-model="admin.username" :class="{ 'is-invalid': submitadd && $v.admin.username.$error }" placeholder="ادخل اسم المستخدم"></b-form-input>
                    <div v-if="submitadd && $v.admin.username.$error" class="invalid-feedback">
                      <span v-if="!$v.admin.username.required"> هذا الحقل الزامي </span>
                      <span v-if="!$v.admin.username.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 3 احرف على الاقل .</span>
                      <span v-if="!$v.admin.username.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 30 حرف على الاكثر . </span>
                    </div>
                </b-form-group>
              </div>

              <hr class="mt-4"> <div class="break-title"><h5>منح الصلاحيات</h5></div> 

              <div class="row">
                <div class="col-md-3 dis-flex" v-for="role in this.roles" v-bind:key="role.id">
                  <div class="con-border pb-2 mt-4">
                    <h5>{{role.title}}</h5>
                    <b-form-checkbox class="mb-1" 
                      v-for="permission in role.permissions" v-bind:key="permission.id"
                      v-model="admin.permissions"
                      :id="'permission_'+permission.id"
                      :value="permission.id" plain >{{permission.title}}</b-form-checkbox>
                  </div>
                </div>
              </div>

              <div class="">
                <hr>
                <b-button class="btn-block" type="submit" variant="primary" :disabled="this.loadingButton">
                  <b-spinner v-if="loadingButton" small></b-spinner> 
                  <span v-else>
                    <i class="bx bx-check font-size-16 align-middle me-2"></i>حفظ
                  </span>
                </b-button>
                <router-link :to="{ name: 'admins.index'}">
                  <b-button class="f-left" type="button" variant="secondary">رجوع</b-button>
                </router-link>
              </div>

            </b-form>
            
            <!-- loading content -->
            <div v-else>
              <vue-content-loading :rtl="true" :width="400" :height="183">
                <rect x="0" y="4" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="8" rx="1" ry="1" width="197" height="10" />
                <rect x="203" y="4" rx="1" ry="1" width="50" height="2" />
                <rect x="203" y="8" rx="1" ry="1" width="197" height="10" />

                <rect x="0" y="23" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="27" rx="1" ry="1" width="197" height="10" />
                <rect x="203" y="23" rx="1" ry="1" width="50" height="2" />
                <rect x="203" y="27" rx="1" ry="1" width="197" height="10" />

                <rect x="0" y="45" rx="0" ry="0" width="2" height="7" />
                <rect x="4" y="47" rx="1" ry="1" width="30" height="3" />
                <rect x="35" y="48" rx="1" ry="1" width="364" height="1" />

                <rect x="0" y="60" rx="1" ry="1" width="45" height="2" />
                <rect x="0" y="64" rx="1" ry="1" width="95" height="40" />
                <rect x="101" y="60" rx="1" ry="1" width="45" height="2" />
                <rect x="101" y="64" rx="1" ry="1" width="95" height="40" />
                <rect x="202" y="60" rx="1" ry="1" width="45" height="2" />
                <rect x="202" y="64" rx="1" ry="1" width="95" height="40" />
                <rect x="303" y="60" rx="1" ry="1" width="45" height="2" />
                <rect x="303" y="64" rx="1" ry="1" width="95" height="40" />

                <rect x="0" y="110" rx="1" ry="1" width="45" height="2" />
                <rect x="0" y="114" rx="1" ry="1" width="95" height="40" />
                <rect x="101" y="110" rx="1" ry="1" width="45" height="2" />
                <rect x="101" y="114" rx="1" ry="1" width="95" height="40" />
                <rect x="202" y="110" rx="1" ry="1" width="45" height="2" />
                <rect x="202" y="114" rx="1" ry="1" width="95" height="40" />
                <rect x="303" y="110" rx="1" ry="1" width="45" height="2" />
                <rect x="303" y="114" rx="1" ry="1" width="95" height="40" />

                <rect x="0" y="163" rx="1" ry="1" width="400" height="1" />
                <rect x="0" y="167" rx="1" ry="1" width="20" height="10" />
                <rect x="385" y="167" rx="1" ry="1" width="15" height="10" />
              </vue-content-loading>
            </div>

          </div>
        </div>
      </div>
    </div>
    
  </Layout>
</template>